<template lang="pug">
  el-dialog(
    :key="modalKey"
    :title="title()"
    :visible.sync="localVisible"
    width="70%"
    :before-close="closeDialog"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :show-close="false"
  )
    inline-form(
      :formAttributes="dialogForm.attributes"
      ref="dialogForm"
    )
      template(slot="actions" slot-scope="scope")
        el-row.inline-form__actions
          el-button(@click="closeDialog()") Cancelar
          el-button(
            type="primary"
            @click.prevent="submit"
            :loading="submitLoading"
          ) Guardar
</template>

<script>
import SelectInput from '@/components/forms/inputs/SelectInput.vue';
import FinanceApi from '@/services/apiService';
import InlineForm from '../forms/InlineForm.vue';

import DateService from '../../services/dateService';

import flattenForm from '../../utils/flattenForm';
import formatForm from '../../utils/formatForm';

export default {
  name: 'NewCommissionModal',
  components: {
    SelectInput,
    InlineForm,
  },
  props: {
    visible: Boolean,
    data: Object,
    country: String,
    source: String,
    agencyEcommerce: { type: Boolean, default: false },
  },
  data() {
    return {
      localVisible: this.visible,
      dialogForm: { visible: false, attributes: {}, data: {} },
      submitLoading: false,
      modalKey: 0,
    };
  },
  watch: {
    visible(newVal) {
      this.localVisible = newVal;
      if (newVal) {
        this.initializeAttributes();
      }
    },
  },
  methods: {
    title() {
      return this.agencyEcommerce ? 'Editar comisión agencia ecommerce' : 'Editar Comisión';
    },
    sourceTitle() {
      if (this.source === 'bus_operator') { return 'operador'; }
      if (this.source === 'agency') { return 'agencia'; }
      return 'grupo';
    },
    initializeAttributes() {
      this.modalKey = Date.now();
      const attributes = { ...this.formAttributes };
      this.dialogForm.attributes = attributes;
      const name = this.dialogForm.attributes.rows[0][0];
      const comission = this.dialogForm.attributes.rows[0][1];
      name.value = this.data.name;
      comission.value = this.textCommission();
      this.dialogForm.data = { ...this.data };
    },
    closeDialog() {
      this.$emit('close');
    },
    startSubmitLoading() {
      this.submitLoading = true;
    },
    stopSubmitLoading() {
      this.submitLoading = false;
    },
    validateInput(input) {
      if (input === undefined || input === null || input === '') {
        return false;
      }
      return true;
    },
    validateForm() {
      const attributes = formatForm(null, flattenForm(this.dialogForm.attributes.rows));
      this.validForm = true;

      if (attributes.commission.value === 0.0) {
        this.validForm = false;
        this.$notify({
          title: 'Valor de comisión',
          message: 'El valor de la comisión no puede ser 0%',
          type: 'error',
        });
      }

      if (this.validateInput(attributes.commission.from) === false) {
        this.validForm = false;
        this.$notify({
          title: 'Fecha de comisión',
          message: 'La fecha de comisión no puede estar vacía',
          type: 'error',
        });
      }
    },
    confirmText() {
      return `¿Estás seguro de que deseas crear esta nueva comisión para el ${this.sourceTitle()}?`;
    },
    submit() {
      this.startSubmitLoading();
      this.validateForm();
      if (this.validForm) {
        this.$confirm(this.confirmText(), '¡Cuidado!', {
          confirmButtonText: 'SÍ',
          cancelButtonText: 'NO',
          type: 'warning',
        }).then(() => {
          const { id } = this.dialogForm.data;
          const attributes = formatForm(id, flattenForm(this.dialogForm.attributes.rows));
          this.saveCommission(attributes);
        }).catch(() => { this.stopSubmitLoading(); });
      } else {
        this.stopSubmitLoading();
      }
    },
    saveCommission(attributes) {
      const commissionAttributes = {
        ...attributes, type: this.source, agencyEcommerce: this.agencyEcommerce,
      };
      FinanceApi.saveCommission(this.data.id, commissionAttributes).then(() => {
        this.closeDialog();
        this.$emit('data-saved');
        this.$notify({
          title: 'Correcto',
          message: 'Comisión creada correctamente',
          type: 'success',
        });

        if (this.dialogForm.data.pablo_conciliable === true) {
          this.$alert(
            `Este ${this.sourceTitle()} pertenece a Pablo. \n\nPara finalizar la actualización, informa al equipo de soporte.`,
            'Importante', {
              confirmButtonText: 'Aceptar',
              dangerouslyUseHTMLString: true,
              type: 'warning',
            },
          );
        }

        this.stopSubmitLoading();
      }).catch((e) => {
        this.$notify({
          title: 'Error',
          message: e.body.errors,
          type: 'error',
        });
        this.stopSubmitLoading();
      });
    },
    textCommission() {
      const commission = this.agencyEcommerce
        ? this.data.agency_ecommerce_commission
        : this.data.commission;
      if (!commission) { return ''; }
      if (commission.to) {
        return `${commission.value}% desde el ${DateService.getDate(commission.from, 'DD MMMM YYYY')} hasta el ${DateService.getDate(commission.to, 'DD MMMM YYYY')}`;
      }
      return `${commission.value}% desde el ${DateService.getDate(commission.from, 'DD MMMM YYYY')}`;
    },
  },
  computed: {
    formAttributes() {
      return {
        rows: [
          [
            {
              key: 'name', value: null, inputType: 'description', label: 'Nombre', length: 24,
            },
            {
              key: 'commission', value: null, inputType: 'description', label: 'Comisión vigente', length: 18,
            },
          ],
          [
            {
              title: 'Comisión',
              grouped: true,
              rows: [
                {
                  key: 'commission.value', value: 0, inputType: 'percentage', label: 'Valor Comisión',
                },
                {
                  key: 'commission.from', value: null, inputType: 'date', label: 'Desde', size: 'mini',
                },
              ],
            },
          ],
        ],
      };
    },
  },
};
</script>

<style scoped>
.data-card {
  padding-top: 20px;
  margin-bottom: 10px;
}
.el-form-item{
  margin-bottom: 10px;
}
.el-row{
  padding-top: 10px
}
</style>
